module.exports = __webpack_public_path__ + "img/logo.e9b16dfb.png";